import './App.css';
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { FaPhone, FaEnvelope, FaChair } from "react-icons/fa";

function App() {
    return (
        <BrowserRouter>

            <Header />

            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/krzeslo-chiavari" element={<ProductPage />} />
            </Routes>

            <Footer />

        </BrowserRouter>
    );
}

function Header() {
    return (
        <header className="header">
            <div className="header-inner">
                <a href="/" className="logo-link">
                    <FaChair />
                    Krzesła-Toruń.pl
                </a>
            </div>
        </header>
    );
}

function HomePage() {
    return (
        <div className="App">
            <main className="container">
                <section className="hero">
                    <h2>Wynajem krzeseł Toruń</h2>

                    <p>
                        Oferujemy eleganckie złote krzesła Chiavari na wesela,
                        przyjęcia, bankiety i eventy.
                    </p>

                    <p>
                        Zapewniamy kompleksową obsługę logistyczną wraz z dostawą, wniesieniem oraz rozstawieniem krzeseł na miejscu.
                    </p>

                    <a href="tel:+48795536919" className="cta-button">
                        Zapytaj o termin
                        <FaPhone/>
                    </a>
                </section>

                <section className="products">
                    <h2>Dostępne krzesła</h2>

                    <Link to="/krzeslo-chiavari" className="product-card">
                        <img
                            src="/IMG_6325.jpg"
                            alt="Złote krzesło Chiavari"
                        />

                        <div className="product-content">
                            <h3>Złote krzesło Chiavari</h3>

                            <p>
                                Klasyczne krzesło weselne w kolorze złotym.
                                Idealne do sal weselnych, ślubów plenerowych
                                oraz eleganckich przyjęć.
                            </p>

                            <div className="price">
                                18 zł / szt.
                            </div>
                        </div>
                    </Link>
                </section>
            </main>


        </div>
    );
}

function ProductPage() {
    return (
        <main className="container product-page">

            <div className="image-slider">

                <img src="/IMG_6325.jpg" alt="Zdjecie 1" />
                <img src="/IMG_6326.jpg" alt="Zdjecie 2" />
                <img src="/IMG_6328.jpeg" alt="Zdjecie 3" />

            </div>

            <div className="product-info">

                <h2>Złote krzesło Chiavari</h2>

                <div className="price-big">18 zł / szt.</div>

                <ul>
                    <li>dostępność: 135 sztuk</li>
                    <li>krzesła metalowe</li>
                    <li>biała poduszka z ekoskóry w cenie</li>
                    <li>wniesienie i rozstawienie w cenie</li>
                    <li>dostawa wyliczania indywidualnie</li>
                </ul>

                <a href="tel:+48795536919" className="cta-button">
                    Zapytaj o dostępność <FaPhone />
                </a>

            </div>

        </main>
    );
}

function Footer() {
    return (
        <footer className="footer">

            <div className="footer-contact">
                <a href="tel:+48795536919" className="footer-link">
                        <span className="footer-icon">
                            <FaPhone />
                        </span>
                    +48 795 536 919
                </a>

                <a href="mailto:krzesla-torun@gmail.com" className="footer-link">
                        <span className="footer-icon">
                            <FaEnvelope />
                        </span>
                    krzesla-torun@gmail.com
                </a>
            </div>

            <div className="footer-info">
                <p>Wynajem krzeseł Chiavari na wesela i eventy.</p>
                <p>Toruń i okolice.</p>
            </div>

            <div className="footer-copy">
                © 2026 Krzesła-Toruń.pl
            </div>

        </footer>
    );
}

export default App;